import pick from 'lodash/pick';
import Order, { OrderColumns } from 'communication/types/order/Order';
import { OrdersAction, OrdersActionType } from './actions';
import { initialOrdersState, OrdersState } from './OrdersState';
import { Reducer } from 'redux';

import {
    StreamStatusActionType,
    StreamStatusStoppedAction,
} from 'streamsState/store/streamStatuses/actions';

export const ordersStateReducer: Reducer<
    OrdersState,
    OrdersAction | StreamStatusStoppedAction
> = (state = initialOrdersState, action) => {
    switch (action.type) {
        case StreamStatusActionType.STREAM_STATUS_SET_STOPPED: {
            // Reset channel when the orders stream is stopped...
            if (action.payload!.streamKey === state.streamKey) {
                return {
                    ...state,
                    streamKey: undefined, // Forces the next start to use a new channel
                    streamingColumns: [], // Forces the next start to send up all the columns
                };
            }
            return state;
        }
        case OrdersActionType.ORDERS_STREAM_CLEAR: {
            return {
                ...state,
                data: [],
                streamingOrderIds: [],
                batchUpdateInProgress: false,
            };
        }
        case OrdersActionType.ORDERS_STREAM_SET_BATCH_UPDATE_IN_PROGRESS: {
            return { ...state, batchUpdateInProgress: true };
        }
        case OrdersActionType.ORDERS_WATCH_STREAM: {
            return {
                ...state,
                streamKey: action.payload!.streamKey,
            };
        }

        case OrdersActionType.ORDERS_UPDATE_STREAMING_COLUMNS:
            return {
                ...state,
                streamingColumns: action.payload!,
            };

        case OrdersActionType.ORDERS_UPDATE_STREAMING_ORDER_IDS:
            return {
                ...state,
                streamingOrderIds: action.payload!,
            };

        case OrdersActionType.ORDERS_SET_ORDERS:
            return {
                ...state,
                data: action.payload!.orders,
                batchUpdateInProgress: action.payload!.batchUpdateInProgress,
                firstBatchComplete:
                    state.firstBatchComplete ||
                    (state.batchUpdateInProgress &&
                        !action.payload!.batchUpdateInProgress),
            };

        case OrdersActionType.ORDERS_UNWATCH_COLUMNS: {
            return {
                ...state,
                data: pickColumns(state.data, action.payload!.remainingColumns),
            };
        }
    }
    return state;
};

function pickColumns(
    data: Order[] | undefined,
    cols: OrderColumns
): Order[] | undefined {
    if (!data) {
        return undefined;
    }
    for (let i = 0; i < data.length; i++) {
        if (data[i] !== undefined) {
            data[i] = pick(data[i], cols);
        }
    }
    return data;
}
